export default __webpack_public_path__ + "static/media/bg-masthead-2-640w.68c680f8.jpg";